import { defineStore } from 'pinia';
import { ref } from '@nuxtjs/composition-api';

export const useSelectorStepsStore = defineStore('selectorStepsStore', () => {
  const model = ref(1)
  const selectedRouterSku = ref('')
  const playServicesSelected = ref(false)
  const routers = ref([])
  const subscription = ref({})
  const category = ref(null)
  const hasError = ref(false)

  return {
    model,
    selectedRouterSku,
    playServicesSelected,
    routers,
    subscription,
    category,
    hasError
  }
})
